import { getLocale } from "../runtime";

const sv_ltcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Lithuania`
};

const ltcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_ltcountryenglish(inputs)
	return "ltCountryEnglish";
};

export { ltcountryenglish as "ltCountryEnglish" };